import * as React from 'react';
import {useMemo} from 'react';
import FormDialog, {Fields, FormDialogProps} from 'cl-dialogs/FormDialog';
import AmazonSitesSelect, {INITIAL_AMAZON_SITE} from '../DialogComponents/AmazonSitesSelect';
import FormInput from 'cl-form/FormInput';
import {Channels} from 'cl-api';
import GeneralActions from '../../../ActionsManager/GeneralActions/GeneralActions';
import {GENERAL_ACTIONS_TYPES} from '../../../ActionsManager/ActionsTypes';
import {ACTION_DISPLAY_TYPES} from '../../../ActionsManager/ActionsManagerConsts';
import EbaySiteSelect from '../DialogComponents/EbaySiteSelect';

export interface AddChannelAccountFormData {
  accountName: string;
  site: string;
}

export interface AddChannelAccountDialogProps extends FormDialogProps {
  channel: Channels;
}

const AddChannelAccountDialog: React.FunctionComponent<AddChannelAccountDialogProps> = ({channel, ...props}) => {
  const channelFields = useMemo(() => {
    switch (channel) {
      case Channels.Amazon:
        return [
          {
            component: FormInput,
            name: 'accountName',
            label: 'Account alias',
            explanationText: 'This is how this account will be called in CrazyLister',
          },
          {component: AmazonSitesSelect, name: 'site', label: 'Amazon site'},
        ];
      case Channels.EBay:
        return [
          {
            component: EbaySiteSelect,
            name: 'site',
            label: 'eBay site',
            explanationText: 'The connected account will allow you to view and publish listings on ALL eBay sites.',
            explanationTooltip: true,
          },
        ];
    }
  }, [channel]);

  const initialValues = useMemo(() => {
    switch (channel) {
      case Channels.Amazon:
        return {accountName: '', site: INITIAL_AMAZON_SITE};
      case Channels.EBay:
        return {site: 'US'};
    }
  }, [channel]);

  return (
    <FormDialog<AddChannelAccountFormData>
      formName={GENERAL_ACTIONS_TYPES.ADD_CHANNEL_ACCOUNT}
      initialValues={initialValues}
      title={`Add ${channel} account`}
      text={
        <div>
          {' '}
          You'll be redirected to {channel} in order to login to your account and agree to the terms and conditions.
          <br />
          Following that, you'll be redirected back here.
        </div>
      }
      fields={channelFields as Fields}
      actions={
        <GeneralActions
          types={[GENERAL_ACTIONS_TYPES.ADD_CHANNEL_ACCOUNT]}
          displayType={ACTION_DISPLAY_TYPES.FLAT_BUTTON}
          lastActionColor="primary"
          additionalActionData={{channel}}
        />
      }
      {...props}
    />
  );
};

export default AddChannelAccountDialog as React.FunctionComponent<AddChannelAccountDialogProps>;
